import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Toolbar,
  Typography,
  Switch,
  FormControlLabel,
  TextField,
  CircularProgress,
  Alert,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
export default function AdmittedBatchBranchMapping() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [feeStatusMap, setFeeStatusMap] = useState({});
  const [batches, setBatches] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [branches, setBranches] = useState([]);
  const [mappings, setMappings] = useState([]);
  const [programMappings, setProgramMappings] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedBatchId, setSelectedBatchId] = useState("ALL");
  const [selectedProgramId, setSelectedProgramId] = useState("ALL");
  const [pageSize, setPageSize] = useState(25);
  const [intakeDialogOpen, setIntakeDialogOpen] = useState(false);
  const [selectedIntakeRow, setSelectedIntakeRow] = useState(null);
  const [intakeDraft, setIntakeDraft] = useState("");
  const [feeLoading, setFeeLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [feeDialogOpen, setFeeDialogOpen] = useState(false);
  const [selectedFeeRow, setSelectedFeeRow] = useState(null);
  const [feeSaving, setFeeSaving] = useState(false);
  const [feeRows, setFeeRows] = useState([]);
  const [feePdfReady, setFeePdfReady] = useState(false);
  const [feePdfLoading, setFeePdfLoading] = useState(false);
  const [batchFeeRows, setBatchFeeRows] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const feeHeaderStyle = {
    border: "1px solid #ddd",
    padding: "8px",
    background: "#f5f5f5",
    fontWeight: 600,
    textAlign: "center",
  };

  const feeCellStyle = {
    border: "1px solid #ddd",
    padding: "6px",
  };
  const user = useMemo(() => {
    const u = sessionStorage.getItem("user");
    return u ? JSON.parse(u) : null;
  }, []);
  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({
      ...prev,
      open: false,
    }));
  };
  const fetchFeeStatus = useCallback(async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/fee-tuition-terms/${user.client_id}/${user.college_id}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const feeData = Array.isArray(res.data?.data) ? res.data.data : [];

      const map = {};

      feeData.forEach((item) => {
        const mappingId = item.admittedbatch_branch_id;

        if (mappingId !== null && mappingId !== undefined) {
          map[String(mappingId)] = true;
        }
      });

      setFeeStatusMap(map);
    } catch (err) {}
  }, [user, API_BASE_URL]);
  const handleOpenFeeDialog = async (row) => {
    try {
      const admittedbatchBranchId =
        row.mapping_id || row.admittedbatch_branch_id || row.admittedbatchBranchId;

      if (!admittedbatchBranchId) {
        setSnackbar({
          open: true,
          message: "Branch mapping ID is missing for this row.",
          severity: "error",
        });

        return;
      }

      setSelectedFeeRow({
        ...row,
        mapping_id: admittedbatchBranchId,
      });

      setFeeLoading(true);
      setFeeDialogOpen(true);

      const yearNumbers = getYearNumbers(row.admittedbatch);

      const defaultRows = [
        ...yearNumbers.map((yearNumber) => ({
          seat_type: "C",
          year_number: yearNumber,
          total_fee: "",
          term1: "",
          term2: "",
          term3: "",
          remarks: "",
        })),

        ...yearNumbers.map((yearNumber) => ({
          seat_type: "M",
          year_number: yearNumber,
          total_fee: "",
          term1: "",
          term2: "",
          term3: "",
          remarks: "",
        })),
      ];

      setFeeRows(defaultRows);

      const response = await axios.get(
        `${API_BASE_URL}/api/fee-tuition-terms/${user.client_id}/${user.college_id}/${admittedbatchBranchId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      if (response.data?.success && Array.isArray(response.data.data)) {
        const existingFees = response.data.data;

        const mergedRows = [
          ...yearNumbers.map((yearNumber) => {
            const existing = existingFees.find(
              (item) =>
                String(item.seat_type || "C") === "C" &&
                Number(item.year_number) === Number(yearNumber)
            );

            return {
              seat_type: "C",
              year_number: yearNumber,
              total_fee:
                existing?.total_fee !== null && existing?.total_fee !== undefined
                  ? String(existing.total_fee)
                  : "",
              term1: existing?.term1 != null ? String(existing.term1) : "",

              term2: existing?.term2 != null ? String(existing.term2) : "",

              term3: existing?.term3 != null ? String(existing.term3) : "",

              remarks: existing?.remarks || "",
            };
          }),

          ...yearNumbers.map((yearNumber) => {
            const existing = existingFees.find(
              (item) =>
                String(item.seat_type || "M") === "M" &&
                Number(item.year_number) === Number(yearNumber)
            );

            return {
              seat_type: "M",
              year_number: yearNumber,
              total_fee:
                existing?.total_fee !== null && existing?.total_fee !== undefined
                  ? String(existing.total_fee)
                  : "",
              term1: existing?.term1 != null ? String(existing.term1) : "",

              term2: existing?.term2 != null ? String(existing.term2) : "",

              term3: existing?.term3 != null ? String(existing.term3) : "",

              remarks: existing?.remarks || "",
            };
          }),
        ];

        setFeeRows(mergedRows);
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.response?.data?.message || "Failed to load tuition fees",
        severity: "error",
      });
    } finally {
      setFeeLoading(false);
    }
  };
  const getYearNumbers = (batchText) => {
    const years = batchText.split("-");

    if (years.length !== 2) return [1];

    const start = Number(years[0]);
    const end = Number(years[1]);

    const duration = end - start;

    return Array.from({ length: duration }, (_, index) => index + 1);
  };
  const getNumber = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const handleFeeChange = (index, field, value) => {
    setFeeRows((prev) => {
      const updated = [...prev];

      updated[index] = {
        ...updated[index],
        [field]: value,
      };

      // Copy Year 1 values to the other years of the same seat type
      if (Number(updated[index].year_number) === 1) {
        const seatType = updated[index].seat_type;

        updated.forEach((row, i) => {
          if (i !== index && row.seat_type === seatType) {
            updated[i] = {
              ...updated[i],
              [field]: value,
            };
          }
        });
      }

      return updated;
    });
  };
  const handleAdmittedBatchChange = async (event) => {
    const batchId = event.target.value;

    setSelectedBatchId(batchId);
    setFeePdfReady(false);
    setBatchFeeRows([]);

    if (!batchId || batchId === "ALL") {
      return;
    }

    try {
      const url =
        `${API_BASE_URL}/api/fee-tuition-terms/` +
        `${user.client_id}/${user.college_id}/batch/${batchId}/status`;

      const res = await axios.get(url, {
        headers: getAuthHeaders(),
      });

      const status = res.data?.data;

      setFeePdfReady(status?.ready === true);
    } catch (error) {
      console.error("Fee batch status error:", error.response?.data || error);

      setFeePdfReady(false);
    }
  };
  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token");
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const fetchBatches = useCallback(async () => {
    if (!user) return;
    try {
      const url = `${API_BASE_URL}/api/admittedbatches/${user.client_id}/${user.college_id}?status=ACTIVE`;
      const res = await axios.get(url, { headers: getAuthHeaders() });
      const data =
        res.data && res.data.items ? res.data.items : Array.isArray(res.data) ? res.data : [];
      setBatches(data || []);
    } catch (err) {
      showSnackbar("Failed to load admitted batches", "error");
      setBatches([]);
    }
  }, [user, API_BASE_URL]);

  const fetchPrograms = useCallback(async () => {
    if (!user) return;
    try {
      const url = `${API_BASE_URL}/api/programs/${user.client_id}/${user.college_id}?status=ACTIVE`;
      const res = await axios.get(url, { headers: getAuthHeaders() });
      const data = res.data && (Array.isArray(res.data) ? res.data : res.data.data);
      setPrograms(Array.isArray(res.data) ? res.data : data || []);
    } catch (err) {
      showSnackbar("Failed to load programs", "error");
      setPrograms([]);
    }
  }, [user, API_BASE_URL]);

  const fetchBranches = useCallback(async () => {
    if (!user) return;
    try {
      const url = `${API_BASE_URL}/api/branches/${user.client_id}/${user.college_id}`;
      const res = await axios.get(url, { headers: getAuthHeaders() });
      const data = Array.isArray(res.data) ? res.data : res.data?.data || res.data?.items || [];
      setBranches(data || []);
    } catch (err) {
      showSnackbar("Failed to load branches", "error");
      setBranches([]);
    }
  }, [user, API_BASE_URL]);

  const fetchMappings = useCallback(async () => {
    if (!user) return;
    try {
      const url = `${API_BASE_URL}/api/map_admittedbatch_branch/${user.client_id}/${user.college_id}`;
      const res = await axios.get(url, { headers: getAuthHeaders() });
      const data =
        res.data && (Array.isArray(res.data) ? res.data : res.data.data)
          ? Array.isArray(res.data)
            ? res.data
            : res.data.data
          : [];
      setMappings(data || []);
    } catch (err) {
      showSnackbar("Failed to load branch mappings", "error");
      setMappings([]);
    }
  }, [user, API_BASE_URL]);
  const validateFeeRows = () => {
    for (const row of feeRows) {
      const totalFee = Number(row.total_fee || 0);

      const term1 = Number(row.term1 || 0);
      const term2 = Number(row.term2 || 0);
      const term3 = Number(row.term3 || 0);

      const termsTotal = term1 + term2 + term3;

      if (Math.abs(totalFee - termsTotal) > 0.01) {
        return (
          `${row.seat_type === "C" ? "Convener" : "Management"} ` +
          `Year ${row.year_number}: ` +
          `Total Fee (${totalFee.toFixed(2)}) must equal ` +
          `Term 1 + Term 2 + Term 3 ` +
          `(${termsTotal.toFixed(2)})`
        );
      }
    }

    return null;
  };
  const hasInvalidFeeRows = feeRows.some((row) => {
    const totalFee = Number(row.total_fee || 0);

    const termsTotal = Number(row.term1 || 0) + Number(row.term2 || 0) + Number(row.term3 || 0);

    return Math.abs(totalFee - termsTotal) > 0.01;
  });
  const handleSaveFees = async () => {
    if (!selectedFeeRow) {
      return;
    }
    const validationError = validateFeeRows();

    if (validationError) {
      setSnackbar({
        open: true,
        message: validationError,
        severity: "error",
      });
      return;
    }
    const confirmed = window.confirm("Are you sure you want to save the tuition fee structure?");

    if (!confirmed) {
      return;
    }

    try {
      setFeeSaving(true);

      await axios.post(
        `${API_BASE_URL}/api/fee-tuition-terms`,
        {
          client_id: user.client_id,

          college_id: user.college_id,

          admittedbatch_branch_id: selectedFeeRow.mapping_id,

          created_by: user.user_email || user.user_email_id || user.user_name || "system",

          feeRows,
        },
        {
          headers: getAuthHeaders(),
        }
      );
      await fetchFeeStatus();
      await fetchMappings();
      setFeeDialogOpen(false);

      setSelectedFeeRow(null);

      setFeeRows([]);

      // Your existing snackbar
      setSnackbar({
        open: true,
        message: "Tuition fees saved successfully",
        severity: "success",
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.response?.data?.message || "Failed to save tuition fees",
        severity: "error",
      });
    } finally {
      setFeeSaving(false);
    }
  };
  const fetchProgramMappings = useCallback(async () => {
    if (!user) return;
    try {
      const url = `${API_BASE_URL}/api/map_admittedbatch_program/${user.client_id}/${user.college_id}`;
      const res = await axios.get(url, { headers: getAuthHeaders() });
      const data =
        res.data && (Array.isArray(res.data) ? res.data : res.data.data)
          ? Array.isArray(res.data)
            ? res.data
            : res.data.data
          : [];
      setProgramMappings(data || []);
    } catch (err) {
      showSnackbar("Failed to load program mappings", "error");
      setProgramMappings([]);
    }
  }, [user, API_BASE_URL]);

  useEffect(() => {
    if (!user) return;
    setLoading(true);
    Promise.all([
      fetchBatches(),
      fetchPrograms(),
      fetchBranches(),
      fetchMappings(),
      fetchProgramMappings(),
      fetchFeeStatus(),
    ])
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }, [
    user,
    fetchBatches,
    fetchPrograms,
    fetchBranches,
    fetchMappings,
    fetchProgramMappings,
    fetchFeeStatus,
  ]);

  useEffect(() => {
    const newRows = [];
    let idx = 1;

    batches.forEach((b) => {
      programs.forEach((p) => {
        const programMapped = programMappings.some(
          (pm) =>
            Number(pm.admittedbatch_id) === Number(b.admittedbatch_id) &&
            Number(pm.program_id) === Number(p.program_id)
        );

        if (!programMapped) return;

        const programBranches = branches.filter(
          (br) => Number(br.program_id) === Number(p.program_id)
        );

        programBranches.forEach((br) => {
          const map = mappings.find(
            (m) =>
              Number(m.admittedbatch_id) === Number(b.admittedbatch_id) &&
              Number(m.program_id) === Number(p.program_id) &&
              Number(m.branch_id) === Number(br.branch_id)
          );

          const mappingId = map?.admittedbatch_branch_id;

          const isFeeSet =
            mappingId !== null &&
            mappingId !== undefined &&
            feeStatusMap[String(mappingId)] === true;

          newRows.push({
            id: `${b.admittedbatch_id}_${p.program_id}_${br.branch_id}`,

            sn: idx++,

            admittedbatch_id: b.admittedbatch_id,
            admittedbatch: b.admittedbatch,

            program_id: p.program_id,
            program_name: p.program_name || p.program || "",

            branch_id: br.branch_id,
            branch_name: br.branch_name || "",

            intake: map ? Number(map.intake) || 0 : 0,

            mapped: Boolean(map),

            mapping_id: mappingId || null,

            fee_status: isFeeSet ? "SET" : "NOT SET",
          });
        });
      });
    });

    const uniqueRows = Array.from(new Map(newRows.map((row) => [row.id, row])).values());

    setRows(uniqueRows);
  }, [batches, programs, branches, mappings, programMappings, feeStatusMap]);

  const handleToggle = async (row) => {
    if (!user) {
      showSnackbar("User not authenticated", "error");
      return;
    }

    setRows((prev) => prev.map((r) => (r.id === row.id ? { ...r, mapped: !r.mapped } : r)));

    try {
      if (!row.mapped) {
        const payload = {
          client_id: user.client_id,
          college_id: user.college_id,
          admittedbatch_id: row.admittedbatch_id,
          program_id: row.program_id,
          branch_id: row.branch_id,
          created_by: user.user_email || user.user_email_id || null,
        };

        const res = await axios.post(`${API_BASE_URL}/api/map_admittedbatch_branch`, payload, {
          headers: getAuthHeaders(),
        });

        const created = res.data && (res.data.data || res.data) ? res.data.data || res.data : null;

        if (created && created.admittedbatch_branch_id) {
          setRows((prev) =>
            prev.map((r) =>
              r.id === row.id ? { ...r, mapping_id: created.admittedbatch_branch_id } : r
            )
          );
        }

        showSnackbar("Mapped successfully", "success");
        fetchMappings();
      } else {
        if (row.mapping_id) {
          await axios.delete(`${API_BASE_URL}/api/map_admittedbatch_branch/${row.mapping_id}`, {
            headers: getAuthHeaders(),
            data: { client_id: user.client_id },
          });
        } else {
          await axios.request({
            url: `${API_BASE_URL}/api/map_admittedbatch_branch`,
            method: "delete",
            headers: getAuthHeaders(),
            data: {
              client_id: user.client_id,
              college_id: user.college_id,
              admittedbatch_id: row.admittedbatch_id,
              program_id: row.program_id,
              branch_id: row.branch_id,
            },
          });
        }

        showSnackbar("Unmapped successfully", "success");
        fetchMappings();
      }
    } catch (err) {
      console.error("toggle mapping", err);
      const errorMessage = err.response?.data?.message || "Failed to update mapping";
      showSnackbar(errorMessage, "error");
      setRows((prev) => prev.map((r) => (r.id === row.id ? { ...r, mapped: row.mapped } : r)));
    }
  };

  const handleSaveIntake = async () => {
    if (!selectedIntakeRow || !user) {
      return;
    }

    const nextIntake = Number(intakeDraft);
    if (!Number.isInteger(nextIntake) || nextIntake < 0) {
      showSnackbar("Please enter a valid intake number", "error");
      return;
    }

    try {
      const payload = {
        client_id: user.client_id,
        college_id: user.college_id,
        admittedbatch_id: selectedIntakeRow.admittedbatch_id,
        program_id: selectedIntakeRow.program_id,
        branch_id: selectedIntakeRow.branch_id,
        intake: nextIntake,
        created_by: user.user_email || user.user_email_id || "system",
      };

      const res = await axios.post(`${API_BASE_URL}/api/map_admittedbatch_branch`, payload, {
        headers: getAuthHeaders(),
      });

      const created = res.data && res.data.data ? res.data.data : null;
      const updatedId = created?.admittedbatch_branch_id || selectedIntakeRow.mapping_id || null;

      setRows((prev) =>
        prev.map((row) =>
          row.id === selectedIntakeRow.id
            ? {
                ...row,
                intake: nextIntake,
                mapped: true,
                mapping_id: updatedId,
              }
            : row
        )
      );

      setIntakeDialogOpen(false);
      setSelectedIntakeRow(null);
      setIntakeDraft("");
      await fetchMappings();
      showSnackbar(res.data?.message || "Branch intake saved successfully", "success");
    } catch (err) {
      console.error("save intake", err);
      showSnackbar(err.response?.data?.message || "Failed to save intake", "error");
    }
  };
  const handleFeeTermsPdf = async () => {
    if (!selectedBatchId || selectedBatchId === "ALL" || !feePdfReady) {
      return;
    }

    try {
      setFeePdfLoading(true);

      const url =
        `${API_BASE_URL}/api/fee-tuition-terms/` +
        `${user.client_id}/${user.college_id}/batch/${selectedBatchId}/pdf-data`;

      const res = await axios.get(url, {
        headers: getAuthHeaders(),
      });

      const data = res.data?.data;

      if (!data?.rows?.length) {
        setSnackbar({
          open: true,
          message: "No fee data available",
          severity: "error",
        });

        return;
      }

      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const collegeName = data.college_name || "";
      const collegCode = data.college_code || "";
      const affiliation = data.affiliation || "";

      const admittedBatch = data.admittedbatch_name || "";

      // College name
      doc.setFont("helvetica", "bold");
      doc.setFontSize(15);

      doc.text(collegeName, pageWidth / 2, 12, {
        align: "center",
      });

      // Affiliation
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);

      doc.text(`Affiliation: ${affiliation}`, pageWidth / 2, 18, {
        align: "center",
      });

      // Report heading
      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);

      doc.text("FEE TERMS OF TUITIONFEE", pageWidth / 2, 26, {
        align: "center",
      });

      // Batch
      doc.setFontSize(10);

      doc.text(`Admitted Batch: ${admittedBatch}`, 14, 33);
      doc.text(`College Code: ${collegCode}`, 160, 33);
      const tableRows = data.rows.map((row, index) => [
        index + 1,

        row.program_name || "",
        row.branch_name || "",
        row.seat_type === "C" ? "Convener" : "Management",
        Number(row.total_fee || 0).toFixed(2),
        Number(row.term1 || 0).toFixed(2),
        Number(row.term2 || 0).toFixed(2),
        Number(row.term3 || 0).toFixed(2),
      ]);

      autoTable(doc, {
        startY: 37,

        head: [
          [
            "S.No.",

            "Program Name",
            "Branch Name",
            "Seat Type",
            "Total Fee",
            "Term-1",
            "Term-2",
            "Term-3",
          ],
        ],

        body: tableRows,

        theme: "grid",

        styles: {
          textColor: [0, 0, 0],
          fontSize: 9,
          cellPadding: 2,
          valign: "middle",
        },

        headStyles: {
          fillColor: [255, 230, 250], // Blue (#1976d2)
          textColor: [0, 0, 0], // Black
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          fontSize: 9,
        },

        columnStyles: {
          0: {
            cellWidth: 12,
            halign: "center",
          },

          1: {
            cellWidth: 30,
          },
          2: {
            cellWidth: 40,
          },
          3: {
            cellWidth: 25,
            halign: "center",
          },
          4: {
            cellWidth: 23,
            halign: "right",
          },
          5: {
            cellWidth: 20,
            halign: "right",
          },
          6: {
            cellWidth: 20,
            halign: "right",
          },
          7: {
            cellWidth: 20,
            halign: "right",
          },
        },

        margin: {
          left: 10,
          right: 10,
        },

        didDrawPage: (pageData) => {
          const pageNumber = doc.internal.getNumberOfPages();

          doc.setFontSize(8);

          doc.text(`Page ${pageNumber}`, pageWidth - 10, pageHeight - 10, {
            align: "right",
          });
        },
      });

      doc.save(`${collegCode}_Fee_Terms_${admittedBatch}.pdf`);
    } catch (error) {
      console.error("Fee terms PDF error:", error);

      setSnackbar({
        open: true,
        message: error.response?.data?.message || "Unable to generate Fee Terms PDF",
        severity: "error",
      });
    } finally {
      setFeePdfLoading(false);
    }
  };
  const columns = [
    { field: "sn", headerName: "S.No", width: 80 },
    { field: "admittedbatch", headerName: "Admitted Batch", flex: 1, minWidth: 180 },
    { field: "program_name", headerName: "Program Name", flex: 1, minWidth: 220 },
    { field: "branch_name", headerName: "Branch Name", flex: 1.2, minWidth: 240 },
    {
      field: "intake",
      headerName: "Branch Intake",
      width: 150,
      minWidth: 140,
      type: "number",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Button
          size="medium"
          variant="outlined"
          onClick={() => {
            setSelectedIntakeRow(params.row);
            setIntakeDraft(String(Number(params.row.intake ?? 0)));
            setIntakeDialogOpen(true);
          }}
          sx={{
            minWidth: 90,
            textTransform: "none",
            color: "#000",
            borderColor: "rgba(0, 0, 0, 0.35)",
            "&:hover": {
              borderColor: "rgba(0, 0, 0, 0.55)",
              color: "#000",
            },
          }}
        >
          {Number(params.row.intake ?? 0)}
        </Button>
      ),
    },
    {
      field: "fee_status",
      headerName: "Fee Status",
      width: 140,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Box
          sx={{
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            color: "#fff",
            fontWeight: 400,
            backgroundColor: params.value === "SET" ? "#2e7d32" : "#d32f50",
          }}
        >
          {params.value}
        </Box>
      ),
    },
    {
      field: "fee_setup",
      headerName: "Fee Setup",
      width: 140,
      sortable: false,
      renderCell: (params) => (
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={() => handleOpenFeeDialog(params.row)}
          sx={{ color: "#fff", "&:hover": { color: "#fff" } }}
        >
          Set Fee
        </Button>
      ),
    },
    {
      field: "mapped",
      headerName: "Map/Unmap",
      width: 130,
      sortable: false,
      renderCell: (params) => (
        <FormControlLabel
          control={<Switch checked={params.row.mapped} onChange={() => handleToggle(params.row)} />}
          label={params.row.mapped ? "Mapped" : "Unmapped"}
        />
      ),
    },
  ];

  const filteredRows = useMemo(() => {
    return rows.filter((r) => {
      if (selectedBatchId !== "ALL" && String(r.admittedbatch_id) !== String(selectedBatchId)) {
        return false;
      }
      if (selectedProgramId !== "ALL" && String(r.program_id) !== String(selectedProgramId)) {
        return false;
      }
      return true;
    });
  }, [rows, selectedBatchId, selectedProgramId]);

  return (
    <Box p={2}>
      <Paper elevation={1}>
        <Toolbar sx={{ gap: 1 }}>
          <Typography variant="h5" sx={{ flexGrow: 1 }}>
            ADMITTED BATCH - BRANCH MAPPING
          </Typography>

          <TextField
            select
            size="medium"
            label="Select Admitted Batch"
            name="admitted_batch"
            InputLabelProps={{ shrink: true }}
            SelectProps={{ native: true, displayEmpty: true }}
            value={selectedBatchId}
            onChange={handleAdmittedBatchChange}
            sx={{ minWidth: 220 }}
          >
            <option value="ALL">-- All Batches --</option>
            {batches.map((b) => (
              <option key={b.admittedbatch_id} value={String(b.admittedbatch_id)}>
                {b.admittedbatch}
              </option>
            ))}
          </TextField>

          <TextField
            select
            size="medium"
            label="Select Program"
            name="program"
            InputLabelProps={{ shrink: true }}
            SelectProps={{ native: true, displayEmpty: true }}
            value={selectedProgramId}
            onChange={(e) => setSelectedProgramId(e.target.value)}
            sx={{ minWidth: 220 }}
          >
            <option value="ALL">All Programs</option>
            {programs.map((p) => (
              <option key={p.program_id} value={String(p.program_id)}>
                {p.program_name || p.program}
              </option>
            ))}
          </TextField>
          <Button
            variant="contained"
            startIcon={<PictureAsPdfIcon />}
            disabled={
              selectedBatchId === "ALL" || !selectedBatchId || !feePdfReady || feePdfLoading
            }
            onClick={handleFeeTermsPdf}
            sx={{
              backgroundColor: "#1976d2",
              color: "#fff",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#1565c0",
              },
            }}
          >
            {feePdfLoading ? "Generating..." : "Fee Terms PDF"}
          </Button>
        </Toolbar>

        <Box
          ml={2}
          mr={2}
          sx={{
            height: 560,
          }}
        >
          <DataGrid
            rows={filteredRows}
            columns={columns}
            loading={loading}
            pagination
            pageSize={pageSize}
            rowsPerPageOptions={[10, 25, 50]}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            disableSelectionOnClick
            getRowId={(r) => r.id}
            sx={{
              "& .MuiDataGrid-cell": { borderBottom: "1px solid #e0e0e0" },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f5f5f5",
                borderBottom: "2px solid #e0e0e0",
              },
            }}
          />
        </Box>
      </Paper>

      <Dialog
        open={intakeDialogOpen}
        onClose={() => {
          setIntakeDialogOpen(false);
          setSelectedIntakeRow(null);
          setIntakeDraft("");
        }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Update Branch Intake</DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 1 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {selectedIntakeRow?.branch_name || "Branch"} ·{" "}
              {selectedIntakeRow?.program_name || "Program"}
            </Typography>
            <TextField
              label="Intake Number"
              type="number"
              value={intakeDraft}
              onChange={(event) => setIntakeDraft(event.target.value)}
              fullWidth
              inputProps={{ min: 0, step: 1 }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setIntakeDialogOpen(false);
              setSelectedIntakeRow(null);
              setIntakeDraft("");
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSaveIntake}
            sx={{ color: "#fff", "&:hover": { color: "#fff" } }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={feeDialogOpen}
        onClose={() => {
          if (!feeSaving) {
            setFeeDialogOpen(false);
          }
        }}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          Tuition Fee Setup
          {selectedFeeRow && (
            <Typography
              variant="body2"
              sx={{
                mt: 0.5,
                color: "text.secondary",
              }}
            >
              {selectedFeeRow.admittedbatch} | {selectedFeeRow.program_name} |{" "}
              {selectedFeeRow.branch_name}
            </Typography>
          )}
        </DialogTitle>

        <DialogContent>
          {feeLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                py: 4,
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Box sx={{ mt: 1 }}>
              <table
                width="100%"
                style={{
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    <th style={feeHeaderStyle}>Seat Type</th>

                    <th style={feeHeaderStyle}>Year</th>
                    <th style={feeHeaderStyle}>Total Fee</th>

                    <th style={feeHeaderStyle}>Term 1</th>

                    <th style={feeHeaderStyle}>Term 2</th>

                    <th style={feeHeaderStyle}>Term 3</th>

                    <th style={feeHeaderStyle}>Remarks</th>
                  </tr>
                </thead>

                <tbody>
                  {feeRows.map((row, index) => (
                    <tr key={`${row.seat_type}-${row.year_number}`}>
                      <td
                        style={{
                          ...feeCellStyle,
                          fontWeight: 600,
                          textAlign: "center",
                        }}
                      >
                        {row.seat_type === "C" ? "C - Convener" : "M - Management"}
                      </td>

                      <td
                        style={{
                          ...feeCellStyle,
                          textAlign: "center",
                          fontWeight: 600,
                        }}
                      >
                        {row.year_number}
                      </td>
                      <td style={feeCellStyle}>
                        <TextField
                          value={row.total_fee ?? ""}
                          onChange={(e) => handleFeeChange(index, "total_fee", e.target.value)}
                          type="number"
                          size="medium"
                          fullWidth
                          inputProps={{
                            min: 0,
                            step: "0.01",
                          }}
                          placeholder="0.00"
                        />
                      </td>
                      <td style={feeCellStyle}>
                        <TextField
                          fullWidth
                          size="medium"
                          type="number"
                          value={row.term1}
                          onChange={(e) => handleFeeChange(index, "term1", e.target.value)}
                          inputProps={{
                            min: 0,
                            step: "0.01",
                          }}
                        />
                      </td>

                      <td style={feeCellStyle}>
                        <TextField
                          fullWidth
                          size="medium"
                          type="number"
                          value={row.term2}
                          onChange={(e) => handleFeeChange(index, "term2", e.target.value)}
                          inputProps={{
                            min: 0,
                            step: "0.01",
                          }}
                        />
                      </td>

                      <td style={feeCellStyle}>
                        <TextField
                          fullWidth
                          size="medium"
                          type="number"
                          value={row.term3}
                          onChange={(e) => handleFeeChange(index, "term3", e.target.value)}
                          inputProps={{
                            min: 0,
                            step: "0.01",
                          }}
                        />
                      </td>

                      <td style={feeCellStyle}>
                        <TextField
                          fullWidth
                          size="medium"
                          value={row.remarks}
                          onChange={(e) => handleFeeChange(index, "remarks", e.target.value)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  mt: 1,
                  color: "text.secondary",
                }}
              >
                Enter values in Year 1. The values will automatically be copied to the other years
                of the same seat type.
              </Typography>
            </Box>
          )}
          {/* VALIDATION MESSAGE */}
          {feeRows.some((row) => {
            const totalFee = Number(row.total_fee || 0);

            const termsTotal =
              Number(row.term1 || 0) + Number(row.term2 || 0) + Number(row.term3 || 0);

            return totalFee > 0 && termsTotal > totalFee;
          }) && (
            <Alert severity="error" sx={{ mt: 2 }}>
              Term total cannot exceed Total Fee.
            </Alert>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setFeeDialogOpen(false)}
            disabled={feeSaving}
            sx={{
              backgroundColor: "#d32f2f",
              color: "#fff",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#b71c1c",
              },
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleSaveFees}
            disabled={feeSaving || feeLoading || hasInvalidFeeRows}
            sx={{
              backgroundColor: "#1976d2",
              color: "#fff",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#1565c0",
              },
            }}
          >
            {feeSaving ? "Saving..." : "Save Fees"}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={snackbar.severity}
          onClose={handleCloseSnackbar}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </Box>
  );
}
